import { render } from "./VabeneAverageBasketStats.vue?vue&type=template&id=40a68566&ts=true"
import script from "./VabeneAverageBasketStats.vue?vue&type=script&lang=ts"
export * from "./VabeneAverageBasketStats.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__